<template>
    <div>

        <headline>
            Ausstattung
            <template slot="more">
                <attribute-create @created="load"></attribute-create>
            </template>
        </headline>

        <loading v-show="loading"></loading>

        <p v-show="attributes.length === 0 && !loading">
            Keine Ausstattung gefunden. Jetzt Ausstattung hinzufügen.
            <attribute-create @created="load"></attribute-create>
        </p>

        <tailwind-table v-show="attributes.length > 0" :header="['Name', '']">
            <tr v-for="(attribute,i) in attributes" :class="{'bg-gray-50': i%2}">
                <td class="px-6 py-3">{{ attribute.name }}</td>
                <td class="px-6 py-3 text-right">
                    <attribute-edit :attribute="attribute" @updated="load"></attribute-edit>
                </td>
            </tr>
        </tailwind-table>
    </div>
</template>

<script>
import Loading from "../components/UI/Loading.vue";
import Headline from "../components/UI/Headline.vue";
import AttributeCreate from "../components/Attributes/AttributeCreate.vue";
import TailwindTable from "../components/UI/TailwindTable.vue";
import AttributeEdit from "../components/Attributes/AttributeEdit.vue";

export default {
    name: "Attributes",
    components: {AttributeEdit, TailwindTable, AttributeCreate, Headline, Loading},

    data: () => ({
        loading: false,
        attributes: [],
    }),

    created() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            this.$http.get('/admin/attributes')
                .then(result => {
                    this.loading = false;
                    this.attributes = result.data.data;
                }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
    },
}
</script>

<style scoped>

</style>